import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import {getToken} from '@/utils/cookie';
import {
  getAccessToken,
  refreshToken,
  getErpconfig,
  nonexistent,
  getQueryMenu,
  getSinglePageRoleCommon,
  getSinglePageHelp,
  checkAppVersion,
} from '@/utils/user';
import {
  webDataCollectionFn,
  deleteTicket,
  getConfigurationItemData,
  verifyMerchantConfig,
  getRouteMenuKey,
  showPageInitFailureModal,
  isInterceptorHandled,
  resetInterceptorHandled,
  isChunkLoadError,
  getRouteWithoutTicket,
} from "@/utils/common";
import {fetchLangOptions} from "@/utils/pageConfig";
import {validateConfigRouteAccess} from '@/utils/configRouteGuard';
import {clearAllLoading} from '@/utils/loading';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
let countTime = config.curTime;
const routes = [
  {
    path: '/',
    redirect: '/statistics',
    component: () => import('@/components/layout/main'), // 引入主文件
    children: [
      {
        path: '/noPersermission',
        component: () => import('@/components/common/noPersermission')
      },
      {
        path: '/statistics', // 即时经营数据
        component: () => import('@/views/yms/components/statistics/statistics')
      },
      {
        path: '/supplierList', // 供应商管理---供应商列表
        component: () => import('@/views/yms/components/supplierManagement/supplierList')
      },
      {
        path: '/supplierAuditList', // 供应商管理---供应商审核
        component: () => import('@/views/yms/components/supplierManagement/supplierAuditList')
      },
      {
        path: '/supplierLevel', // 供应商管理---供应商等级管理
        component: () => import('@/views/yms/components/supplierManagement/supplierLevel')
      },
      {
        path: '/customerList', // 客户管理---客户列表
        component: () => import('@/views/yms/components/customerManage/customerList')
      },
      {
        path: '/customerLabel', // 客户管理---客户标签
        component: () => import('@/views/yms/components/customerManage/customerLabel')
      },
      {
        path: '/customerGroups', // 客户管理---客户分组
        component: () => import('@/views/yms/components/customerManage/customerGroups')
      },
      {
        path: '/customerGrade', // 客户管理---客户等级
        component: () => import('@/views/yms/components/customerManage/customerGrade')
      },
      {
        path: '/tuokeLink', // 客户管理---拓客链接
        component: () => import('@/views/yms/components/customerManage/tuokeLink')
      },
      {
        path: '/selfOperatedProductsList', // 商品管理---平台自营商品列表
        component: () => import('@/views/yms/components/commodityManage/selfOperatedProductsList')
      },
      {
        path: '/selfOperatedProductsViewSku', // 商品管理---商品列表---查看SKU
        component: () => import('@/components/common/viewSku'),
        meta: {
          parentPath: '/selfOperatedProductsList'
        }
      },
      {
        path: '/selfOperatedProductsDetails', // 商品管理--商品列表---编辑商品
        component: () => import('@/views/yms/components/commodityManage/selfOperatedProductsDetails'),
        meta: {
          parentPath: '/selfOperatedProductsList'
        }
      },
      {
        path: '/productList', // 商品管理---商品列表
        component: () => import('@/views/yms/components/commodityManage/productList')
      },
      {
        path: '/ymsViewSku', // 商品管理---商品列表---查看SKU
        component: () => import('@/components/common/viewSku'),
        meta: {
          parentPath: '/productList'
        }
      },
      {
        path: '/productDetails', // 商品管理--商品列表---编辑商品
        component: () => import('@/components/common/productDetails'),
        meta: {
          parentPath: '/productList'
        }
      },
      {
        path: '/category', // 商品管理---商品分类
        component: () => import('@/views/yms/components/commodityManage/category'),
      },
      {
        path: '/sizeTemplateManage', // 尺码管理
        component: () => import('@/views/yms/components/commodityManage/sizeTemplateManage'),
      },
      {
        path: '/updateSizeTemplate', // 新增/编辑尺码模板
        component: () => import('@/views/yms/components/commodityManage/updateSizeTemplate'),
        meta: {
          parentPath: '/sizeTemplateManage'
        }
      },
      {
        path: '/newProductReviewList', // 商品管理--新品审核列表
        component: () => import('@/views/yms/components/commodityManage/newProductReviewList'),
      },
      {
        path: '/newProductReviewDetails', // 商品管理--新品审核列表---新品审核/编辑商品
        component: () => import('@/components/common/productDetails'),
        meta: {
          parentPath: '/newProductReviewList'
        }
      },
      {
        path: '/productReviewForSaleList', // 商品管理--在售审核列表
        component: () => import('@/views/yms/components/commodityManage/productReviewForSaleList'),
      },
      {
        path: '/productReviewForSaleDetails', // 商品管理--在售审核列表---在售审核/编辑商品
        component: () => import('@/components/common/productDetails'),
        meta: {
          parentPath: '/productReviewForSaleList'
        }
      },
      {
        path: '/findSimilarProducts', // 商品管理--待审核列表--1688找同款
        component: () => import('@/views/yms/components/commodityManage/findSimilarProducts'),
      },
      {
        path: '/itemAttributes', // 商品管理--物品属性池
        component: () => import('@/views/yms/components/commodityManage/itemAttributes'),
      },
      {
        path: '/productLabel', // 商品管理--商品标签
        component: () => import('@/views/yms/components/commodityManage/productLabel'),
      },
      {
        path: '/productSalesPriceConfig', // 商品管理--商品销售价配置
        component: () => import('@/views/yms/components/commodityManage/productSalesPriceConfig'),
      },
      {
        path: '/orderList', // 订单管理---云卖订单
        component: () => import('@/views/yms/components/orderList/orderList')
      },
      {
        path: '/orderListDetails', // 云卖订单详情
        component: () => import('@/views/yms/components/orderList/orderListDetails'),
        meta: {
          parentPath: '/orderList'
        }
      },
      {
        path: '/distributorStockList', // 订单管理--分销商备货单
        component: () => import('@/views/yms/components/orderList/distributorStockList')
      },
      {
        path: '/supplierOrderDetails', // 供应商订单详情
        component: () => import('@/views/yms/components/orderList/supplierOrderDetails')
      },
      {
        path: '/supplierStockList', // 供应商备货单
        component: () => import('@/views/yms/components/orderList/supplierStockList')
      },
      {
        path: '/supplierStockOrderDetails', // 供应商备货单详情
        component: () => import('@/views/yms/components/orderList/supplierStockOrderDetails'),
        meta: {
          parentPath: '/supplierStockList'
        }
      },
      {
        path: '/supplierOrders', // 供应商订单
        component: () => import('@/views/yms/components/orderList/supplierOrders')
      },
      {
        path: '/orderCollectionAccount', // 订单收款账户
        component: () => import('@/views/yms/components/orderList/orderCollectionAccount')
      },
      {
        path: '/orderPaymentReconciliation', // 订单支付对账
        component: () => import('@/views/yms/components/orderList/orderPaymentReconciliation')
      },
      {
        path: '/platformBill', // 财务管理---平台账单
        component: () => import('@/views/yms/components/financialManage/platformBill')
      },
      {
        path: '/platformBillDetails', // 财务管理---平台账单详情
        component: () => import('@/views/yms/components/financialManage/platformBillDetails')
      },
      {
        path: '/supplierBillManage', // 财务管理---供应商账单
        component: () => import('@/views/yms/components/financialManage/supplierBill')
      },
      {
        path: '/supplierBillDetails', // 财务管理---供应商账单详情
        component: () => import('@/views/yms/components/financialManage/supplierBillDetails')
      },
      {
        path: '/customerBill', // 财务管理---客户账单
        component: () => import('@/views/yms/components/financialManage/customerBill')
      },
      {
        path: '/customerBillDetails', // 财务管理---客户账单详情
        component: () => import('@/views/yms/components/financialManage/customerBillDetails')
      },
      {
        path: '/logisticsBill', // 财务管理---物流账单
        component: () => import('@/views/yms/components/financialManage/logisticsBill')
      },
      {
        path: '/logisticsBillDetails', // 财务管理---物流账单详情
        component: () => import('@/views/yms/components/financialManage/logisticsBillDetails'),
        meta: {
          parentPath: '/logisticsBill'
        }
      },
      {
        path: '/warehouseBill', // 财务管理---仓储账单
        component: () => import('@/views/yms/components/financialManage/warehouseBill')
      },
      {
        path: '/warehouseBillDetails', // 财务管理---仓储账单详情
        component: () => import('@/views/yms/components/financialManage/warehouseBillDetails'),
        meta: {
          parentPath: '/warehouseBill'
        }
      },
      {
        path: '/financialJournal', // 财务管理---费用明细
        component: () => import('@/views/yms/components/financialManage/financialJournal')
      },
      {
        path: '/rechargeRecord', // 财务管理---客户余额变动
        component: () => import('@/views/yms/components/financialManage/rechargeRecord')
      },
      {
        path: '/passwordManage', // 财务管理---密码管理
        component: () => import('@/views/yms/components/financialManage/passwordManage')
      },
      {
        path: '/subsidyReview', // 财务管理---补贴审核
        component: () => import('@/views/yms/components/financialManage/subsidyReview')
      },
      {
        path: '/billLadingManage', // 入库管理---提单管理
        component: () => import('@/views/yms/components/collectionManage/billLadingManage')
      },
      {
        path: '/billLadingManageDetails', // 入库管理---提单管理详情
        component: () => import('@/views/yms/components/collectionManage/billLadingManageDetails'),
        meta: {
          parentPath: '/billLadingManage'
        }
      },
      {
        path: '/billWarehousing', // 入库管理---提单入库
        component: () => import('@/views/yms/components/collectionManage/billWarehousing')
      },
      {
        path: '/commoditySorting', // 入库管理---入库分拣
        component: () => import('@/views/yms/components/collectionManage/commoditySorting')
      },
      {
        path: '/commoditySticker', // 入库管理---商品贴单
        component: () => import('@/views/yms/components/collectionManage/commoditySticker')
      },
      {
        path: '/commodityShelves', // 入库管理---商品上架
        component: () => import('@/views/yms/components/collectionManage/commodityShelves')
      },
      {
        path: '/handoverSheetManage', // 入库管理---物流商交接单管理
        component: () => import('@/views/yms/components/collectionManage/handoverSheetManage')
      },
      {
        path: '/handoverSheetManageDetails', // 入库管理---物流商交接单管理详情
        component: () => import('@/views/yms/components/collectionManage/handoverSheetManageDetails'),
        meta: {
          parentPath: '/handoverSheetManage'
        }
      },
      {
        path: '/sortingOut', // 入库管理---物流分拣
        component: () => import('@/views/yms/components/collectionManage/sortingOut')
      },
      {
        path: '/wms/inventoryLevels', // 仓储管理--库存余量
        component: () => import('@/views/yms/components/wms/wms-inStock/inventoryLevels')
      },
      {
        path: '/wms/generateOrderList', // 仓储管理--拣货--生成拣货单
        component: () => import('@/views/yms/components/wms/exWarehouse/generateOrderList')
      },
      {
        path: '/generateOrderDetails', // 仓储管理--拣货--生成拣货单详情
        component: () => import('@/views/yms/components/orderList/orderListDetails'),
        meta: {
          parentPath: '/wms/generateOrderList'
        }
      },
      {
        path: '/generateSupplierOrderDetails', // 仓储管理--拣货--生成拣货单详情--供应商订单详情
        component: () => import('@/views/yms/components/orderList/supplierOrderDetails')
      },
      {
        path: '/wms/pickList', // 仓储管理--拣货--拣货单列表
        component: () => import('@/views/yms/components/wms/exWarehouse/pickList')
      },
      {
        path: '/wms/pickListDetails', // 仓储管理--拣货--拣货单详情
        component: () => import('@/views/yms/components/wms/exWarehouse/pickListDetails'),
        meta: {
          parentPath: '/wms/pickList'
        }
      },
      {
        path: '/wms/sortOrderSetting', // 仓储管理--见货出单---见货出单设置
        component: () => import('@/views/yms/components/wms/exWarehouse/sortOrderSetting')
      },
      {
        path: '/wms/sorting', // 仓储管理--见货出单---多品分拣
        component: () => import('@/views/yms/components/wms/exWarehouse/sorting')
      },
      {
        path: '/wms/packWorking', // 仓储管理--见货出单---包装作业
        component: () => import('@/views/yms/components/wms/exWarehouse/pickingReview')
      },
      {
        path: '/warehouseManage', // 基础设置---仓库管理
        component: () => import('@/views/yms/components/basicSettings/warehouseManage')
      },
      {
        path: '/reservoirManage', // 基础设置---库区管理
        component: () => import('@/views/yms/components/basicSettings/reservoirManage')
      },
      {
        path: '/locationManage', // 基础设置---库位管理
        component: () => import('@/views/yms/components/basicSettings/locationManage')
      },
      {
        path: '/exchangeRateConfig', // 基础设置---汇率配置
        component: () => import('@/views/yms/components/basicSettings/exchangeRateConfig')
      },
      {
        path: '/iossTaxRateSetting', // 基础设置---IOSS税率设置
        component: () => import('@/views/yms/components/basicSettings/iossTaxRateSetting')
      },
      {
        path: '/systemConfigList', // 基础设置---系统配置
        component: () => import('@/views/yms/components/basicSettings/systemConfigList')
      },
      {
        path: '/thirdPartyPlatformList', // 基础设置--第三方平台管理--平台列表
        component: () => import('@/views/yms/components/basicSettings/thirdPartyPlatformList')
      },
      {
        path: '/deliveryLocationManage', // 基础设置--发货地管理
        component: () => import('@/views/yms/components/basicSettings/deliveryLocationManage')
      },
      {
        path: '/ymsLogistics', // 物流管理--YMS物流
        component: () => import('@/views/yms/components/logisticsManage/ymsLogistics')
      },
      {
        path: '/basicLogistics', // 物流管理--基础物流
        component: () => import('@/views/yms/components/logisticsManage/basicLogistics')
      },
      {
        path: '/smartLogisticsRule', // 物流管理--智能物流规则
        component: () => import('@/views/yms/components/logisticsManage/smartLogisticsRule')
      },
      {
        path: '/messageNotification', // 基础设置--消息通知
        component: () => import('@/views/yms/components/basicSettings/messageNotification')
      },
      {
        path: '/siteManage', // 营销管理--站点管理
        component: () => import('@/views/yms/components/marketingManage/siteManage')
      },
      {
        path: '/activityManage', // 营销管理--活动管理
        component: () => import('@/views/yms/components/marketingManage/activityManage')
      },
      {
        path: '/editActivity', // 营销管理--活动管理--新增、编辑活动
        component: () => import('@/views/yms/components/marketingManage/editActivity'),
        meta: {
          parentPath: '/activityManage'
        }
      },
      {
        path: '/advertisingManage', // 营销管理--广告管理
        component: () => import('@/views/yms/components/marketingManage/advertisingManage')
      },
      {
        path: '/rotationChart', // 营销管理--广告管理--首页轮播图
        component: () => import('@/views/yms/components/marketingManage/rotationChart'),
        meta: {
          parentPath: '/advertisingManage'
        }
      },
      {
        path: '/vajraDistrict', // 营销管理--广告管理--金刚区
        component: () => import('@/views/yms/components/marketingManage/vajraDistrict'),
        meta: {
          parentPath: '/advertisingManage'
        }
      },
      {
        path: '/topAdvertisingSpace', // 营销管理--广告管理--顶部广告位
        component: () => import('@/views/yms/components/marketingManage/topAdvertisingSpace'),
        meta: {
          parentPath: '/advertisingManage'
        }
      },
      {
        path: '/sideAdvertisingSpace', // 营销管理--广告管理--侧边广告位
        component: () => import('@/views/yms/components/marketingManage/sideAdvertisingSpace'),
        meta: {
          parentPath: '/advertisingManage'
        }
      },
      {
        path: '/infoAdvertisingSpace', // 营销管理--广告管理--首页-个人信息下方广告位
        component: () => import('@/views/yms/components/marketingManage/infoAdvertisingSpace'),
        meta: {
          parentPath: '/advertisingManage'
        }
      },
      {
        path: '/subsidyRules', // 营销管理--补贴规则
        component: () => import('@/views/yms/components/marketingManage/subsidyRules')
      },
      {
        path: '/distributorFeeAllocation', // 营销管理--分销商费用配置
        component: () => import('@/views/yms/components/marketingManage/distributorFeeAllocation')
      },
      {
        path: '/helpCenter', // 内容管理--帮助中心
        component: () => import('@/views/yms/components/contentManage/helpCenter')
      },
      {
        path: '/questionnaireInvestigation', // 内容管理--问卷调查
        component: () => import('@/views/yms/components/contentManage/questionnaireInvestigation')
      },
      {
        path: '/addQuestionnaire', // 内容管理--问卷调查--新建问卷
        component: () => import('@/views/yms/components/contentManage/questionnaire'),
        meta: {
          parentPath: '/questionnaireInvestigation'
        }
      },
      {
        path: '/editQuestionnaire', // 内容管理--问卷调查--编辑问卷
        component: () => import('@/views/yms/components/contentManage/questionnaire'),
        meta: {
          parentPath: '/questionnaireInvestigation'
        }
      },
      {
        path: '/questionnaireStatistics', // 内容管理--问卷调查--统计
        component: () => import('@/views/yms/components/contentManage/questionnaireStatistics'),
        meta: {
          parentPath: '/questionnaireInvestigation'
        }
      },
      {
        path: '/operatingInstructions', // 内容管理--操作指引
        component: () => import('@/views/yms/components/contentManage/operatingInstructions')
      },
      {
        path: '/systemAnnouncement', // 内容管理--系统公告
        component: () => import('@/views/yms/components/contentManage/systemAnnouncement')
      },
      {
        path: '/deliveryDetails', // 数据中心--出库明细
        component: () => import('@/views/yms/components/dataCenter/deliveryDetails.vue')
      },
      {
        path: '/messageCenter', // 基础设置--消息中心
        component: () => import('@/views/yms/components/basicSettings/messageCenter')
      },
      {
        path: '/messageMailboxes', // 基础设置--消息中心--消息、邮箱查看
        component: () => import('@/views/yms/components/basicSettings/messageMailboxes')
      },
      {
        path: '/containerManage', // 基础设置--容器管理
        component: () => import('@/views/yms/components/basicSettings/containerManage')
      },
      {
        path: '/containerSettings', // 基础设置--容器类型设置
        component: () => import('@/views/yms/components/basicSettings/containerSettings')
      },
      {
        path: '/addressLibraryManage', // 基础设置--地址库管理
        component: () => import('@/views/yms/components/basicSettings/addressLibraryManage')
      },
      {
        path: '/processConfiguration', // 基础设置--出入库流程配置
        component: () => import('@/views/yms/components/basicSettings/processConfiguration')
      },
      {
        path: '/declarationRules', // 基础设置--申报规则
        component: () => import('@/views/yms/components/basicSettings/declarationRules')
      },
      {
        path: '/automaticDistributionRules', // 基础设置--自动分仓规则
        component: () => import('@/views/yms/components/basicSettings/automaticDistributionRules')
      },
      {
        path: '/employeeList', // 员工管理---员工列表
        component: () => import('@/views/yms/components/employeeManage/employeeList')
      },
      {
        path: '/importTask', // 导入/导出任务--导入查看
        component: () => import('@/views/yms/components/importExportTask/importTask')
      },
      {
        path: '/exportTask', // 导入/导出任务---导出查看
        component: () => import('@/views/yms/components/importExportTask/exportTask')
      },
    ]
  },
  {
    path: '/sortingInfo', // 扫描多品常规分拣
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/sortingInfo.vue'], resolve);
    },
    meta: {
      parentPath: '/wms/sorting'
    }
  },
  {
    path: '/choiceSortingInfo', // 扫描多品备货分拣
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/choiceSortingInfo.vue'], resolve);
    },
    meta: {
      parentPath: '/wms/sorting'
    }
  },
  {
    path: '/printPickListBatch',
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/printPickListBatch.vue'], resolve);
    },
    meta: {
      parentPath: '/wms/pickList'
    }
  },
  {
    path: '/printPickList', // 打印拣货单
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/printPickList.vue'], resolve);
    }
  },
  {
    path: '/packingWork', // 常规包装
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/packingWork.vue'], resolve);
    },
    meta: {
      parentPath: '/wms/packWorking'
    }
  },
  {
    path: '/choicePackingWork', // 备货包装
    component: resolve => {
      require(['@/views/yms/components/wms/exWarehouse/choicePackingWork.vue'], resolve);
    },
    meta: {
      parentPath: '/wms/packWorking'
    }
  },
  {
    path: '/commoditySortingOperation', // 入库管理---入库分拣作业
    component: resolve => {
      require(['@/views/yms/components/collectionManage/commoditySortingOperation.vue'], resolve);
    },
    meta: {
      parentPath: '/commoditySorting'
    }
  },
  {
    path: '/commodityStickerOperation', // 入库管理---商品贴单作业
    component: resolve => {
      require(['@/views/yms/components/collectionManage/commodityStickerOperation.vue'], resolve);
    },
    meta: {
      parentPath: '/commoditySticker'
    }
  },
  {
    path: '/merchantSettlement', // 商户入驻
    component: () => import('@/views/yms/components/merchantSettlement/merchantSettlement.vue')
  },
  {
    path: '/previewHelpCenter', // 帮助中心--预览内容
    component: () => import('@/views/yms/components/contentManage/previewHelpCenter')
  },
  {
    path: '/commonHelpCenter', // 帮助中心
    component: () => import('@/components/common/commonHelpCenter.vue')
  },
  {
    path: '/viewGuideContent', // 查系统指引内容
    component: resolve => {
      require(['@/components/layout/viewGuideContent.vue'], resolve);
    }
  },
  {
    path: '/initialConfigPage', // 初始化配置页面
    component: resolve => {
      require(['@/views/yms/components/basicSettings/initialConfigPage'], resolve);
    }
  },
];
const router = new Router({
  mode: 'hash',
  routes
});

// 处理商户入驻
const handleMerchantSettlement = async (to, hasToken, next) => {
  if (to.path !== '/merchantSettlement') return false;
  if (!hasToken) {
    await getAccessToken(to.fullPath);
  }
  if (window.location.href.includes('ticket=')) {
    window.location.href = deleteTicket(window.location.href);
    window.location.reload();
  } else {
    next();
  }
  return true;
}

/**
 * 初始化当前页面进入前需要的基础数据。
 * @param {string} menuKey 当前路由对应的菜单 key。
 * @returns {Promise<{configPassed: boolean}>} 返回初始化配置校验结果。
 */
const initPageData = async (menuKey) => {
  await fetchLangOptions();
  const menu = await getQueryMenu();
  if (menu === null) {
    clearAllLoading();
    return null;
  }
  if (menu === false) {
    throw new Error('getQueryMenu failed');
  }
  const [erp, role, configPassed] = await Promise.all([
    getErpconfig(''),
    getSinglePageRoleCommon(menuKey),
    verifyMerchantConfig(),
  ]);
  if (erp === false) {
    throw new Error('getErpconfig failed');
  }
  if (role === false) {
    throw new Error('getSinglePageRoleCommon failed');
  }
  getSinglePageHelp(menuKey, 'ymsCore').catch((e) => {
    console.error('getSinglePageHelp non-blocking error:', e);
  });
  await getConfigurationItemData();
  return {configPassed};
}

/**
 * 统一处理页面初始化失败场景。
 * @param {Function} next vue-router 导航回调。
 * @param {Error} error 当前初始化异常。
 */
const handlePageInitFailure = (next, error, content) => {
  console.error('router beforeEach error:', error);
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  if (typeof next === 'function') {
    next(false);
  }
  if (isInterceptorHandled) {
    resetInterceptorHandled();
    return;
  }
  showPageInitFailureModal(content);
}
// 路由前置守卫
router.beforeEach(async (to, from, next) => {
  try {
    // 前置检测：版本是否已更新
    const versionChanged = await checkAppVersion();
    if (versionChanged) {
      window.location.reload();
      return;
    }

    localStorage.setItem('system', 'yms');
    const token = getToken();
    const menuKey = getRouteMenuKey(to, 'yms');
    // 无权限 / 404 页面直接放行
    if (to.path === '/noPersermission') {
      await initPageData(menuKey);
      clearAllLoading();
      return next();
    }
    // 入驻页面单独处理
    if (await handleMerchantSettlement(to, token, next)) {
      return;
    }
    // 初始化配置页直接放行
    if (to.path === '/initialConfigPage' && to.query.from === 'guard') {
      clearAllLoading();
      return next();
    }
    // token 处理
    if (token) {
      refreshToken(countTime);
    } else {
      webDataCollectionFn();
      const access = await getAccessToken(to.fullPath);
      if (!access) {
        throw new Error('getAccessToken failed');
      }
      refreshToken(countTime);
      const routeWithoutTicket = getRouteWithoutTicket(to);
      if (routeWithoutTicket) {
        clearAllLoading();
        return next(routeWithoutTicket);
      }
    }
    // 初始化页面依赖数据
    const initResult = await initPageData(menuKey);
    if (initResult === null) {
      resetInterceptorHandled();
      return next(false);
    }
    const {configPassed} = initResult;
    // 配置项路由访问验证
    const configRouteAccess = validateConfigRouteAccess(to, 'yms');
    if (!configRouteAccess) {
      return next(false);
    }
    if (configPassed) {
      clearAllLoading();
      return nonexistent(to, next);
    }
    // 未完成初始化，跳转初始化页
    clearAllLoading();
    next({
      path: '/initialConfigPage',
      query: {from: 'guard'},
      replace: true
    });
  } catch (e) {
    console.error('router beforeEach error:', e);
    handlePageInitFailure(next, e);
  }
});
// 路由错误处理
router.onError((error) => {
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  console.error('router error:', error);
});

export default router;
